export default __webpack_public_path__ + "static/market-research-7848b314041aa4668a29b093e16f3971.png";